var map = {
	"./arrow-left": "./app/frontend/images/arrow-left.png",
	"./arrow-left.png": "./app/frontend/images/arrow-left.png",
	"./default-image": "./app/frontend/images/default-image.png",
	"./default-image.png": "./app/frontend/images/default-image.png",
	"./fabmanager-logo": "./app/frontend/images/fabmanager-logo.png",
	"./fabmanager-logo.png": "./app/frontend/images/fabmanager-logo.png",
	"./getnet": "./app/frontend/images/getnet.png",
	"./getnet.png": "./app/frontend/images/getnet.png",
	"./github": "./app/frontend/images/github.svg",
	"./github.svg": "./app/frontend/images/github.svg",
	"./icons": "./app/frontend/images/icons.svg",
	"./icons.svg": "./app/frontend/images/icons.svg",
	"./mastercard": "./app/frontend/images/mastercard.png",
	"./mastercard.png": "./app/frontend/images/mastercard.png",
	"./no_avatar": "./app/frontend/images/no_avatar.png",
	"./no_avatar.png": "./app/frontend/images/no_avatar.png",
	"./no_image": "./app/frontend/images/no_image.png",
	"./no_image.png": "./app/frontend/images/no_image.png",
	"./pagseguro-logo": "./app/frontend/images/pagseguro-logo.png",
	"./pagseguro-logo.png": "./app/frontend/images/pagseguro-logo.png",
	"./payzen-secure": "./app/frontend/images/payzen-secure.png",
	"./payzen-secure.png": "./app/frontend/images/payzen-secure.png",
	"./powered_by_stripe": "./app/frontend/images/powered_by_stripe.png",
	"./powered_by_stripe.png": "./app/frontend/images/powered_by_stripe.png",
	"./security-site": "./app/frontend/images/security-site.png",
	"./security-site.png": "./app/frontend/images/security-site.png",
	"./social-icons": "./app/frontend/images/social-icons.svg",
	"./social-icons.svg": "./app/frontend/images/social-icons.svg",
	"./social/dailymotion": "./app/frontend/images/social/dailymotion.png",
	"./social/dailymotion.png": "./app/frontend/images/social/dailymotion.png",
	"./social/echosciences": "./app/frontend/images/social/echosciences.png",
	"./social/echosciences.png": "./app/frontend/images/social/echosciences.png",
	"./visa": "./app/frontend/images/visa.png",
	"./visa.png": "./app/frontend/images/visa.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./app/frontend/images sync recursive ^\\.\\/.*$";